import { useQuery } from '@tanstack/react-query';
import { endpoints, ID } from '@rossum/api-client';
import { DedicatedEngineGetQuery } from '@rossum/api-client/dedicatedEngines';
import { api } from '../../../lib/apiClient';

const QUERY_KEY_DEDICATED_ENGINE = 'engine';

export const useDedicatedEngine = (
  engineId: ID | null,
  query: DedicatedEngineGetQuery = {}
) => {
  return useQuery({
    queryKey: [QUERY_KEY_DEDICATED_ENGINE, engineId, query] as const,

    queryFn: () => {
      if (!engineId) throw new Error('No engine ID provided');
      return api.request(endpoints.dedicatedEngines.get(engineId, query));
    },
    enabled: !!engineId,
  });
};
